'use client';
import React from 'react';
import SideNavItem, {
	SideNavItemProps,
} from '../../components/SideNavItem/SideNavItem';
import { icons } from '@/Icons';
import { ModalStatusEnum, useModalStoreActions } from '@/store';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { SectionWrapper } from '../../SideNav';
import useOpenCloseToggle from '../../hooks/useOpenCloseToggle';
import ContentWrapper from '../../components/ContentWrapper/ContentWrapper';
import { WalletTabEnum } from '@/components/Modals/WalletModal/WalletModal';
import { useRouter } from 'next/navigation';

const ProfileLinks = () => {
	const { setModalStatus } = useModalStoreActions();
	const { open, toggleOpen } = useOpenCloseToggle();
	const router = useRouter();

	const profileData: SideNavItemProps[] = [
		{
			title: 'Wallet',
			link: '/account?type=wallet',
			icon: <icons.wallet />,
			onClick: () => {
				setModalStatus(ModalStatusEnum.WalletModal);
				const url = new URL(window.location.href);
				url.searchParams.set('wallet', 'open');
				url.searchParams.set('tab', WalletTabEnum.Deposit);
				router.replace(url.pathname + url.search);
			},
			authRequired: true,
		},
		{
			title: 'Transactions',
			link: '/account?type=transactions',
			icon: <icons.transactions />,
			authRequired: true,
		},
		{
			title: 'Settings',
			link: '/account?type=profile',
			icon: <icons.settings />,
			authRequired: true,
		},
	];

	return (
		<SectionWrapper>
			<SectionTitle title="Profile" toggleOpen={toggleOpen} open={open} />
			<ContentWrapper open={open}>
				{profileData.map((item, index) => {
					return <SideNavItem key={index} {...item} />;
				})}
			</ContentWrapper>
		</SectionWrapper>
	);
};

export default ProfileLinks;
